import { graphql, PageProps } from 'gatsby'
import React, { FC } from 'react'
import LandingPageContent from '../components/landing-page-content/landing-page-content.component'
import { PageTypeDisplayText } from '../components/navigation/navigation.utils'
import { SiteSeo } from '../components/seo/seo.component'
import WidgetTile from '../components/widget-tile/widget-tile.component'
import { DevelopIcon } from '../constants/icons.constants'
import { SITE_SEO_META } from '../constants/site-seo.constants'
import getSideNavDataFromPages from '../gatsby/create-page-sidenav.utility'
import ConfigurePageLayout from '../layouts/page/page-layout-configure.component'
import getContentfulTileStructure from '../utilities/contentful-groups-to-links.utility'

type DevelopPageProps = PageProps<{
  allContentfulPage: GatsbyTypes.ContentfulPageConnection
}>

const DevelopPage: FC<DevelopPageProps> = ({ data }) => {
  const { sideNavsRecord } = getSideNavDataFromPages(data.allContentfulPage.nodes)
  const cards = getContentfulTileStructure(data.allContentfulPage, sideNavsRecord.Develop)
  return (
    <ConfigurePageLayout sideNavs={sideNavsRecord.Develop} type="Develop">
      <SiteSeo title={SITE_SEO_META.DEVELOP.title} description={SITE_SEO_META.DEVELOP.description} />

      <LandingPageContent icon={DevelopIcon} title={PageTypeDisplayText('Develop')}>
        Installing, using, and contributing to Vista Design System code
      </LandingPageContent>

      <div className="responsive-grid no-hover-link">
        {cards.map(card => (
          <WidgetTile key={card.id} tile={card} />
        ))}
      </div>
    </ConfigurePageLayout>
  )
}

export default DevelopPage

export const query = graphql`
  query {
    allContentfulPage(filter: { type: { eq: "Develop" } }) {
      nodes {
        ...sideNav
      }
    }
  }
`
